export default "__VITE_ASSET__CzxmuYmh__"